// The shared account has a server-side location (from the user's zip code, set on
// mobile or via ZipOnboard). The backend REQUIRES lat/lng on /recipients/nearby and
// /feed, so we read the account's saved coordinates from the user object rather than
// browser GPS (which would be a wrong datacenter/desktop location).
export const userCoords = (user) => {
  const lat = user?.lat ?? user?.latitude ?? null;
  const lng = user?.lng ?? user?.longitude ?? null;
  return lat != null && lng != null ? { lat: Number(lat), lng: Number(lng) } : null;
};

// Back-compat: callers that used the old hook get no browser coords.
export const useGeo = () => ({ coords: null, ready: true });
